import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { NavService } from './nav.service'
import { NavItem } from '@shared/nav-list-item.component'
import { NAV_ITEMS } from './nav-items.const'
import { Store, select } from '@ngrx/store'
import { AppState } from './core/store'
import { RoleGuard } from './guards/role-guard.service'
import { selectAuthState } from './core/store/auth/auth.selectors'
import { Subscription } from 'rxjs'
import { State } from './core/store/auth/auth.state.facade'

@Component({
  selector: 'app-nav-list-container',
  styleUrls: ['./nav-list.container.scss'],
  template: `
    <mat-nav-list disableRipple>
      <app-nav-list-item
        *ngFor="let item of items"
        [item]="item"
        [expandedMap]="expandedMap"
        (itemSelect)="onItemSelect($event)"
      ></app-nav-list-item>
    </mat-nav-list>
  `,
})
export class NavListContainerComponent implements OnInit, OnDestroy {
  expandedMap: Record<string, boolean> = {}
  allowedGuards: Set<string>
  navSubscription: Subscription

  constructor(
    public router: Router,
    private navService: NavService,
    private cd: ChangeDetectorRef,
    private store: Store<AppState>,
    private roleGuard: RoleGuard,
  ) {}

  ngOnInit() {
    this.navSubscription = this.navService.currentUrl.subscribe(() => {
      this.navService.currentUrl.subscribe(() => this.cd.markForCheck())
      this.store.pipe(select(selectAuthState)).subscribe((data) => {
        if (data.userPermissions && data.security) {
          this.allowedGuards = this.roleGuard.checkPermissions(data.userPermissions, data.security)
          this.items.map((item) => {
            item.disabled = item.route ? this.checkDisabled(item.route) : false
            if (item.children) {
              item.children.map((child) => {
                child.disabled = child.route ? this.checkDisabled(child.route) : false
                if (child.children) {
                  child.children.map((grandchild) => {
                    grandchild.disabled = grandchild.route
                      ? this.checkDisabled(grandchild.route)
                      : false
                  })
                  if (this.allChildrenItemsDisabled(child)) {
                    child.disabled = true
                  }
                }
              })

              if (this.allChildrenItemsDisabled(item)) {
                item.disabled = true
              }
            }
          })
        }
      })
      this.store.pipe(select(selectAuthState)).subscribe((data) => {
        /* To protect against refreshes */
        const selectedApp = this.getSelectedApp(data)

        this.items.map((item) => (item.disabled = this.disableNavigationItem(item, selectedApp)))
      })
    })
    this.expandedMap['SAGE Structuring Tool'] = false
    this.expandedMap.Group = true
  }

  getSelectedApp(data: State): string {
    if (data.selectedApp && data.selectedApp !== '') {
      return data.selectedApp
    }

    const isFac =
      this.router.url === '/facultative' ||
      this.router.url === '/facultative-admin' ||
      this.router.url === '/fac-management-information'

    return isFac ? 'facultative' : 'sage'
  }

  disableNavigationItem(item: NavItem, selectedApp: string): boolean | undefined {
    if (
      selectedApp === 'facultative' &&
      item.displayName !== 'Facultative' &&
      item.displayName !== 'Facultative Administration' &&
      item.displayName !== 'FAC Management Information'
    ) {
      return true
    }

    if (
      selectedApp === 'sage' &&
      (item.displayName === 'Facultative' ||
        item.displayName === 'Facultative Administration' ||
        item.displayName === 'FAC Management Information')
    ) {
      return true
    }

    if (
      selectedApp === 'sage' &&
      item.displayName !== 'Facultative' &&
      item.displayName !== 'Facultative Administration' &&
      item.displayName !== 'FAC Management Information'
    ) {
      return item.disabled
    }

    return false
  }

  getKey(item: NavItem): string {
    return item.route || item.displayName
  }

  onItemSelect(item: NavItem): void {
    if (!item.children || !item.children.length) {
      this.router.navigate([item.route])
      this.navService.close()
    } else {
      const _expanded = this.expandedMap[this.getKey(item)]
      this.expandedMap[this.getKey(item)] = !_expanded
    }
  }

  checkDisabled(route: string) {
    // TODO: Remove when permissions added to backend
    // return false
    if (this.allowedGuards) {
      return !this.allowedGuards.has(route)
    }
  }

  ngOnDestroy() {
    this.navSubscription.unsubscribe()
  }

  items: NavItem[] = structuredClone(NAV_ITEMS)

  allChildrenItemsDisabled(item: NavItem): boolean {
    const foundEnabled = item.children?.some((c) => !c.disabled)

    return !foundEnabled
  }
}
